import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import React, { useState, useEffect } from "react";
import { Editor } from "@wangeditor/editor-for-react";
import { DomEditor } from "@wangeditor/editor";

const MyRichTextEditor = ({ value, ...props }) => {
  // editor 实例
  const [editor, setEditor] = useState(null);

  // 编辑器内容
  const [html, setHtml] = useState("");

  useEffect(() => {
    if (value !== html) {
      setHtml(value);
    }
  }, [value]);

  // 编辑器配置
  const editorConfig = {
    readOnly: true, // 设置为只读模式
    placeholder: "",
    autoFocus: false,
    hoverbarKeys: {
      text: [],
    },
    MENU_CONF: {
      codeBlock: {
        highlightjs: true,
        languages: [
          { text: "Plain Text", value: "text" },
          { text: "JavaScript", value: "javascript" },
          { text: "HTML", value: "html" },
          { text: "CSS", value: "css" },
          { text: "Python", value: "python" },
          { text: "Java", value: "java" },
        ],
      },
    },
  };

  // 处理编辑器创建完成事件
  const handleCreated = (editor) => {
    setEditor(editor);

    // 添加自定义样式
    const style = document.createElement("style");
    style.textContent = `
      .w-e-text-container {
        border: none !important;
      }
      .w-e-text-container pre {
        background-color: #f6f8fa;
        border-radius: 6px;
        padding: 16px;
        margin: 16px 0;
        position: relative;
      }
      .w-e-text-container code {
        font-family: Consolas, Monaco, 'Andale Mono', monospace;
        font-size: 14px;
        line-height: 1.6;
        white-space: pre-wrap;
        word-break: break-all;
        display: block;
      }
    `;
    document.head.appendChild(style);

    // 合并代码块的函数
    const mergeCodeBlocks = () => {
      const container = editor.getEditableContainer();
      if (!container) return;

      const pres = Array.from(container.querySelectorAll("pre"));
      if (pres.length <= 1) return;

      // 获取所有代码内容
      let allCode = "";
      pres.forEach((pre, index) => {
        const code = pre.querySelector("code");
        if (code) {
          allCode += (index > 0 ? "\n" : "") + code.textContent;
        }
      });

      // 保留第一个代码块，删除其他的
      if (allCode) {
        const firstPre = pres[0];
        const firstCode = firstPre.querySelector("code");
        if (firstCode) {
          firstCode.textContent = allCode;

          // 删除其他代码块
          pres.slice(1).forEach((pre) => pre.remove());
        }
      }
    };

    // 在内容加载后执行合并
    setTimeout(() => {
      mergeCodeBlocks();
      editor.updateView(); // 更新编辑器视图
    }, 100);
  };

  // 及时销毁 editor ，重要！
  useEffect(() => {
    return () => {
      if (editor == null) return;
      editor.destroy();
      setEditor(null);
    };
  }, [editor]);

  return (
    <div style={{ border: "none" }}>
      <Editor
        defaultConfig={editorConfig}
        value={html}
        onCreated={handleCreated}
        mode="default"
        style={{ minHeight: "50px", height: "auto" }}
      />
    </div>
  );
};

export default MyRichTextEditor;
